import React, { Component } from 'react';
import Checkbox from '../Checkbox';
import Select from '../Select/Select';
export default class GamesFilters extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showSessions: false
		}
	}
	render() {
		const {
			onChangeCoordinator,
			coordinator,
			onChangeSessionID,
			sessionID,
			sessions,
			showCoordinator,
			showSessionsSelect
		} = this.props;
		const {
			showSessions
		} = this.state;
		const options = [
			{
				value: 'all',
				description: 'All Sessions'
			},
			...sessions.map( session => ({
				value: session.id,
				description: session.name
			}))
		]
		return (
			<div className="AdminGames-filter">
				{
					showCoordinator && <Checkbox
						clicked={onChangeCoordinator}
						checked={coordinator}
						value="coordinator"
						name="coordinator-check"
					>
						Show only coordinators
					</Checkbox>
				}
				{
					showSessionsSelect && <div className="AdminGames-field">
						<label className="AdminGames-label">Select session</label>
						<Select
							small
							clicked={() => this.setState({ showSessions: !showSessions })}
							itemClicked={ev => {
								this.setState({ showSessions: !showSessions })
								onChangeSessionID(ev)
							}}
							placeholder={'All sessions'}
							name={'session-filter'}
							value={sessionID}
							showList={showSessions}
							styles={{
								width: '200px',
								margin: 0
							}}
							items={options}
						/>
					</div>
				}
			</div>
		);
	}
}
